import { render, staticRenderFns } from "./CompanyAccountForm.vue?vue&type=template&id=4cc41e25&"
import script from "./CompanyAccountForm.vue?vue&type=script&lang=js&"
export * from "./CompanyAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports